<div class="container-table">
  <table
    matSort
    (matSortChange)="sortData($event)"
    [matSortActive]="defaultSort && dataSource.length > 1 ? defaultSort.ColumnOrder : ''"
    [matSortDirection]="defaultSort?.OrderDirection"
    [matSortDisabled]="!(dataSource.length > 1)"
    matSortDisableClear
    [ngClass]="{ tableFixed: tableFixed }"
  >
    <caption></caption>
    <colgroup *ngFor="let column of columnsToDisplay; index as j">
      <col [ngClass]="column.columnClass" />
    </colgroup>
    <thead>
      <tr>
        <ng-container *ngFor="let column of columnsToDisplay; index as j">
          <th scope="col" *ngIf="column.sort" [mat-sort-header]="column.field[0] !== '' ? column.field[0] : j">
            {{ column.label | i18nextEager }}
          </th>
          <th scope="col" *ngIf="!column.sort" [ngClass]="{ checkInput: column.field[0] === 'check' }">
            <mat-checkbox
              *ngIf="column.field[0] === 'check' && dataSource?.length > 0"
              [checked]="allCheckbox"
              (change)="checkedAllData($event.checked)"
            >
            </mat-checkbox>
            {{ column.label | i18nextEager }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="dataSource.length; else tableWithoutDataTemplate">
        <ng-container
          *ngTemplateOutlet="
            recursiveListTmpl;
            context: {
              list: dataSource,
              display: columnsToDisplay,
              child: false
            }
          "
        ></ng-container>
        <ng-template #recursiveListTmpl let-list="list" let-display="display" let-child="child">
          <ng-container *ngFor="let item of list; index as i">
            <tr [ngClass]="{ lastBlankRow: lastBlankRow, child: child, warn: isWarnedRow(item) }">
              <td *ngFor="let column of display; let x = index" [ngClass]="!child ? column.fieldClass : ''">
                <ng-container *ngFor="let linea of column.fieldClass; index as l">
                  <span class="{{ column.fieldClass[l] }}">
                    <ng-container [ngSwitch]="column.fieldClass[l]">
                      <ng-container
                        *ngSwitchCase="
                          column.fieldClass[l] === 'button' ||
                          column.fieldClass[l] === 'buttonFixed' ||
                          column.fieldClass[l] === 'buttonRowHidden'
                            ? column.fieldClass[l]
                            : !column.fieldClass[l]
                        "
                      >
                        <img
                          *ngIf="
                            column.action === 'expand' && item[column.field[l]] && item[column.field[l]].length > 0
                          "
                          (click)="moreClicked(item)"
                          src="/assets/icons/chevron.svg"
                          class="icon"
                          [ngClass]="{ rotate180: item.expanded }"
                          alt="chevron"
                        />
                        <img
                          *ngIf="
                            column.action === 'expandWithCall' && column.field.length === 2 && item[column.field[1]]
                          "
                          (click)="getMoreClicked(item)"
                          src="/assets/icons/chevron.svg"
                          class="icon"
                          [ngClass]="{ rotate180: item.expanded }"
                          alt="chevron"
                        />
                        <img
                          *ngIf="
                            (column.action !== 'expand' &&
                              column.action !== 'expandWithCall' &&
                              (column?.hiddenIcon ? list[i][column.hiddenIcon[l]] : true) &&
                              column.fieldClass[l] !== 'buttonRowHidden') ||
                            (column.fieldClass[l] === 'buttonRowHidden' && showButtons[column.field[l]][i])
                          "
                          (click)="handleButton(column.action, list[i])"
                          class="icon"
                          src="{{ '/assets/icons/' + column.nameIcon + '.svg' }}"
                          alt="{{ column.nameIcon }}"
                        />
                      </ng-container>
                      <ng-container *ngSwitchCase="'opinionCredito'">
                        <div *ngIf="list[i][column.field[l]] === 'APROBADO'" class="flag-green">
                          {{ 'NEW_CONTRACTS.APPROVED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === 'CL'" class="flag-gray">
                          {{ 'NEW_CONTRACTS.CLASSIFIED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === 'CN'" class="flag-red">
                          {{ 'NEW_CONTRACTS.CANCELED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === 'CP'" class="flag-yellow">
                          {{ 'NEW_CONTRACTS.PARTIAL_GRANTED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === 'CT'" class="flag-green">
                          {{ 'NEW_CONTRACTS.GRANTED' | i18nextEager }}
                        </div>
                        <div
                          *ngIf="list[i][column.field[l]] === 'RJ' || list[i][column.field[l]] === 'RZ'"
                          class="flag-orange"
                        >
                          {{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === 'RD'" class="flag-default">
                          {{ 'NEW_CONTRACTS.REDUCED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === ''" class="flag-default">
                          {{ 'NEW_CONTRACTS.DEFAULT' | i18nextEager }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'codEstado'">
                        <div *ngIf="list[i][column.field[l]] === '300000000'">
                          {{ 'REGISTRED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000007'">
                          {{ 'PENDING_MARKETER' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000006'">
                          {{ 'PENDING_CLIENT' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000008'">
                          {{ 'PENDING_DISTRIBUTOR' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000009'">
                          {{ 'PENDING_OTHERS' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000002'">
                          {{ 'RESOLVED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000010' || list[i][column.field[l]] === '5'">
                          {{ 'RESOLVED_AND_CLOSED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000004'">
                          {{ 'CLOSED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '300000005'">
                          {{ 'CANCELLED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '6'">
                          {{ 'CANCELLED_CLOSED' | i18nextEager }}
                        </div>
                        <div *ngIf="list[i][column.field[l]] === '2000'">
                          {{ 'COMBINED' | i18nextEager }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'date'">
                        {{ list[i][column.field[l]] | date: 'dd/MM/yyyy' }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'rangedate'">
                        {{ list[i][column.field[0]] | date: 'dd/MM/yyyy' }} -
                        {{ list[i][column.field[1]] | date: 'dd/MM/yyyy' }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'currency'">
                        {{ list[i][column.field[l]] | currency: 'EUR' }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'number'">
                        {{ list[i][column.field[l]] | number }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'boolean'">
                        {{ (list[i][column.field[l]] ? 'COMMONS.YES' : 'COMMONS.NO') | i18nextEager }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'booleanOrNull'">
                        {{ (list[i][column.field[l]] === true ? 'COMMONS.YES' : (list[i][column.field[l]] === false ? 'COMMONS.NO' : '')) | i18nextEager }}
                      </ng-container>
                      <ng-container *ngSwitchCase="'mail'">
                        <div class="container-icons">
                          <div *ngIf="list[i][column.field[1]]">
                            <a href="{{ 'mailto:' + list[i][column.field[1]] }}" class="icon-mail"></a>
                          </div>
                          <span>{{ list[i][column.field[0]] }}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'estado'">
                        <span>{{ list[i][column.field[0]] }}</span>
                        <img
                          *ngIf="list[i][column.field[1]]"
                          (click)="handleButton(column.action, list[i])"
                          class="icon"
                          src="{{
                            '/assets/icons/' +
                              (list[i][column.conditional.field] === column.conditional.value
                                ? column.nameIcon
                                : column.nameSecondIcon) +
                              '.svg'
                          }}"
                          alt="{{ column.nameIcon }}"
                        />
                      </ng-container>
                      <ng-container *ngSwitchCase="'checkInput'">
                        <mat-checkbox [checked]="checkBoxChecked[i]" (change)="checkedData(i, list[i])"> </mat-checkbox>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        {{ list[i][column.field[l]] }}
                      </ng-container>
                    </ng-container>
                  </span>
                </ng-container>
              </td>
            </tr>
            <ng-container *ngIf="item.expanded">
              <tr *ngIf="rowCustomHeaders?.length > 0" class="child-header-custom">
                <td lass="column.fieldClass" *ngFor="let cols of rowCustomHeaders">{{ cols.label | i18nextEager }}</td>
                <td *ngFor="let emptyCols of columnsToDisplay.slice(rowCustomHeaders.length + 1)"></td>
              </tr>
              <ng-container
                *ngTemplateOutlet="
                  recursiveListTmpl;
                  context: {
                    list: dataSource[i][nameCustomChild],
                    display: rowCustomHeaders?.length > 0 ? rowCustomHeaders : columnsToDisplay,
                    child: true
                  }
                "
              ></ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </ng-container>
      <ng-template #tableWithoutDataTemplate>
        <tr>
          <td colSpan="100%" class="colSpan100">{{ 'COMMONS.WITHOUT_DATA' | i18nextEager }}</td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>

<mat-paginator
  *ngIf="paginatorTable && dataSource.length"
  [showFirstLastButtons]="paginatorTable.showFirstLastButtons"
  [length]="paginatorTable.length"
  [pageIndex]="paginatorTable.pageIndex"
  [pageSize]="paginatorTable.pageSize"
  [pageSizeOptions]="paginatorTable.pageSizeOptions"
  (page)="handlePagination($event)"
></mat-paginator>
